module.exports = __webpack_public_path__ + "static/media/nav3.ce8f2545.svg";